/**
 * 💬 LINE Bot Hub
 * v3.3 IA 刷新: line.users はオーディエンス Hub に分離。LINE Bot は配信運用に集中。
 */
import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';

import { LineNewsPage } from './news/LineNewsPage';
import { DeliveriesPage } from './deliveries/DeliveriesPage';
import { EventsPage } from './events/EventsPage';
import { OfferingsPage } from './offerings/OfferingsPage';
import { QaReviewPage } from './qa-review/QaReviewPage';
import { LineBotSettingsTab } from './settings/LineBotSettingsTab';

const TABS: TabSpec[] = [
  { tabKey: 'news',       label: 'ニュース',  featureId: 'line.news',       render: () => <LineNewsPage /> },
  { tabKey: 'deliveries', label: '配信',      featureId: 'line.deliveries', render: () => <DeliveriesPage /> },
  { tabKey: 'events',     label: 'イベント',  featureId: 'line.events',     render: () => <EventsPage /> },
  { tabKey: 'offerings',  label: '商材',      featureId: 'line.offerings',  render: () => <OfferingsPage /> },
  { tabKey: 'qa-review',  label: 'QAレビュー', featureId: 'line.qa-review',  render: () => <QaReviewPage /> },
  { tabKey: 'settings',   label: '設定',      featureId: 'line.settings',   render: () => <LineBotSettingsTab /> },
];

export function LineHubPage() {
  return <HubTabs tabs={TABS} defaultTab="news" />;
}
